import React, { useState } from 'react';
import {
    useSelector
    // useDispatch
} from 'react-redux';
import {
    Link,
    withRouter
} from 'react-router-dom';

import DrawerToggle from '../sidedrawer/drawertoggle';
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faHome,
    faSignInAlt,
    faListUl,
    faCartArrowDown,
    faUser,
    faHeart,
    faCogs,
    faSearch,
    faChevronDown,
    faEnvelope,
    faChevronUp,
    faCog,
    faCalendar,
    faQuestion,
    faSignOutAlt,
    faShoppingBag,
    faDesktop,
    faBoxes,
    faShippingFast,
    faUsers,
    faCheckDouble,
    faBell,
    faGlobe
} from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

library.add(
    faHome,
    faSignInAlt,
    faListUl,
    faCartArrowDown,
    faUser,
    faHeart,
    faCogs,
    faSearch,
    faChevronDown,
    faEnvelope,
    faChevronUp,
    faCog,
    faCalendar,
    faQuestion,
    faSignOutAlt,
    faShoppingBag,
    faDesktop,
    faBoxes,
    faShippingFast,
    faUsers,
    faCheckDouble
)

const AdminHeader = (props) => {
    const { userprops } = useSelector(state => ({
        userprops: state.user.userData
    }));
    // const dispatch = useDispatch();
    const [profilemenu, profilemenuHandling] = useState(false);
    const [dontblur, dontblurHandling] = useState(false);

    const [notifications, notificationsHandler] = useState(false);
    const [notificationsdontblur, notificationsdontblurHandler] = useState(false);

    const [message, messageHandler] = useState(false);
    const [messagedontblur, messagedontblurHandler] = useState(false);

    const [account] = useState([
        {
            name: 'Profile',
            linkTo: '/admin/profile',
            faicons: faUser
        },
        {
            name: 'Settings',
            linkTo: '/admin/settings',
            faicons: faCog
        },
        {
            name: 'My Calendar',
            linkTo: '/admin/calendar',
            faicons: faCalendar
        }
    ]);
    const [accountbottom] = useState([
        {
            name: 'Help',
            linkTo: '/admin/help',
            faicons: faQuestion
        },
        {
            name: 'Logout',
            linkTo: '/auth/logout',
            faicons: faSignOutAlt
        }
    ]);

    //////////////////////////////////////////////////////////
    const profilemenutoggle = () => {
        // console.log("profilemenutoggle")
        profilemenuHandling(!profilemenu);
    }

    // const showprofilemenu = () => {
    //     console.log("showprofilemenu")
    //     profilemenuHandling(true)
    // }

    const hideprofilemenu = () => {
        // console.log("hideprofilemenu")
        profilemenuHandling(false);
    }

    const onMouseEnter = () => {
        // console.log("onMouseEnter")
        dontblurHandling(true);
    }

    const onMouseLeave = () => {
        // console.log("onMouseLeave")
        dontblurHandling(false);
    }
    //////////////////////////////////////////////////////////

    //////////////////////////////////////////////////////////
    const notificationstoggle = () => {
        notificationsHandler(!notifications);
    }

    const hidenotifications = () => {
        notificationsHandler(false);
    }

    const onNotificationsMouseEnter = () => {
        notificationsdontblurHandler(true);
    }

    const onNotificationsMouseLeave = () => {
        notificationsdontblurHandler(false);
    }
    //////////////////////////////////////////////////////////

    //////////////////////////////////////////////////////////
    const messagetoggle = () => {
        messageHandler(!message);
    }

    const hidemessage = () => {
        messageHandler(false);
    }

    const onMessageMouseEnter = () => {
        messagedontblurHandler(true);
    }

    const onMessageMouseLeave = () => {
        messagedontblurHandler(false);
    }
    //////////////////////////////////////////////////////////

    const logoutLink = (link) => {
        props.history.push(link)
    }

    const showLinks = (type) => {
        let list = [];

        if (userprops) {
            type.forEach((item) => {
                list.push(item)
            });
        }

        return list.map((item, i) => (
            <li
                key={i}
                // onMouseDown={e => e.preventDefault()}
                // onMouseUp={() => this.logoutLink(item.linkTo)}
                onClick={() => logoutLink(item.linkTo)}
                className="listgroupitem"
            >
                <span className="memberHeaderLink">
                    {item.name}
                    <FontAwesomeIcon
                        icon={item.faicons}
                        className="icon"
                    />
                </span>

            </li>
        ))
    }

    const visitPageForMore = (link, thisicon, thistext) => {

        return (
            <li
                onClick={() => props.history.push(link)}
                className="listgroupitem"
            >
                <span className="memberHeaderLink">
                    {thistext}
                    <FontAwesomeIcon
                        icon={thisicon}
                        className="icon"
                    />
                </span>

            </li>
        )
    }

    return (
        <div id="#main">
            <header className="navbar navbarfixedtop">
                <div className="navbarlogowrapper">
                    <Link
                        to="/admin/dashboard"
                        className="navbarlogoimage"
                    >
                        <img className="logo_img mobileHidden" src={window.location.origin + "/assets/images/lumisoft_side_white.png"} alt="" />
                    </Link>
                </div>
                <div className="memberToggleButton">
                    <DrawerToggle click={props.drawerClickHandler} />
                </div>
                <ul className="nav navbarnav navbarright">
                    <li className={profilemenu ? "dropdown dropdownfuse open" : "dropdown dropdownfuse"}>
                        <div
                            className="dropdowntoggle ml0 memberDiv"
                            onClick={() => profilemenutoggle()}
                            onKeyPress={() => profilemenutoggle()}
                            // onMouseDown={e => e.preventDefault()}
                            // onClick={(e) => {
                            //     e.preventDefault()
                            //     e.stopPropagation()
                            //     this.userprofilemenuStatus()
                            // }}
                            // onBlur={() => this.userprofilemenuOnBlur()}
                            onBlur={dontblur ? null : hideprofilemenu}
                            // onFocus={showprofilemenu}
                            // ref={dropdown => this.dropdown = dropdown}
                            tabIndex={0}
                        >
                            <span className="hiddenXs hiddenSm">
                                <span className="name">{userprops ? userprops.name : null}</span>
                            </span>
                            <span className="hiddenXs hiddenSm arrow">
                                {
                                    profilemenu ?
                                        <FontAwesomeIcon
                                            icon={faChevronUp}
                                            className="icon"
                                        />
                                        :
                                        <FontAwesomeIcon
                                            icon={faChevronDown}
                                            className="icon"
                                        />
                                }
                            </span>
                            <span className="profile-online">
                                <img src={window.location.origin + "/assets/images/demonix18.jpg"} alt="avatar" />
                            </span>

                        </div>
                        {
                            profilemenu &&
                            <ul
                                className="dropdownmenu listgroup profilemenu"
                                onMouseEnter={onMouseEnter}
                                onMouseLeave={onMouseLeave}
                            >
                                {showLinks(account)}
                                <li className="divider"></li>
                                {showLinks(accountbottom)}
                            </ul>
                        }
                    </li>
                </ul>
                <ul className="nav navbarnav navbarright">
                    <li className="dropdown dropdownfuse pl15 mr10">
                        <div
                            className="navbarbtn btngroup"
                            style={{ cursor: "pointer" }}
                            onClick={() => props.history.push('/admin/dashboard')}
                        >
                            <button
                                className="btn dropdowntoggle"
                            >
                                <span>
                                    <FontAwesomeIcon
                                        icon={faHome}
                                        className="icon"
                                    />
                                </span>
                            </button>
                        </div>
                    </li>
                    <li className="dropdown dropdownfuse mr10">
                        <div
                            className="navbarbtn btngroup"
                            style={{ cursor: "pointer" }}
                            onClick={() => props.history.push('/admin/website')}
                        >
                            <button
                                className="btn dropdowntoggle"
                            >
                                <span>
                                    <FontAwesomeIcon
                                        icon={faGlobe}
                                        className="icon"
                                    />
                                </span>
                            </button>
                        </div>
                    </li>
                    <li className={message ? "dropdown dropdownfuse mr10 open" : "dropdown dropdownfuse mr10"}>
                        <div
                            className="navbarbtn btngroup"
                            style={{ cursor: "pointer" }}
                            onClick={() => messagetoggle()}
                            onKeyPress={() => messagetoggle()}
                            onBlur={messagedontblur ? null : hidemessage}
                            tabIndex={0}
                        >
                            <button
                                className="btn dropdowntoggle"
                            >
                                <span>
                                    <FontAwesomeIcon
                                        icon={faEnvelope}
                                        className="icon"
                                    />
                                </span>
                            </button>
                            <button className="btn dropdowntoggle bgcolor1 fs10">3</button>
                        </div>
                        {
                            message &&
                            <ul
                                className="dropdownmenu listgroup headermessagemenu"
                                onMouseEnter={onMessageMouseEnter}
                                onMouseLeave={onMessageMouseLeave}
                            >
                                {showLinks(account)}
                                <li className="divider"></li>
                                {visitPageForMore('/admin/message', faEnvelope, 'More Messages')}
                            </ul>
                        }
                    </li>
                    <li className={notifications ? "dropdown dropdownfuse mr10 open" : "dropdown dropdownfuse mr10"}>
                        <div
                            className="navbarbtn btngroup"
                            style={{ cursor: "pointer" }}
                            onClick={() => notificationstoggle()}
                            onKeyPress={() => notificationstoggle()}
                            onBlur={notificationsdontblur ? null : hidenotifications}
                            tabIndex={0}
                        >
                            <button
                                className="btn dropdowntoggle"
                            >
                                <span>
                                    <FontAwesomeIcon
                                        icon={faBell}
                                        className="icon"
                                    />
                                </span>
                            </button>
                            <button className="btn dropdowntoggle bgcolor2 fs10">8</button>
                        </div>
                        {
                            notifications &&
                            <ul
                                className="dropdownmenu listgroup headernotificationmenu"
                                onMouseEnter={onNotificationsMouseEnter}
                                onMouseLeave={onNotificationsMouseLeave}
                            >
                                {showLinks(account)}
                                <li className="divider"></li>
                                {visitPageForMore('/admin/notifications', faBell, 'More Notifications')}
                            </ul>
                        }
                    </li>
                </ul>
            </header>
        </div>
    );
}

export default withRouter(AdminHeader);